/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import { Dialog, makeStyles } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

const useStyles = makeStyles({
  root: ({ styles, isOverflowHidden }: { isOverflowHidden: boolean; styles: any }) => {
    return {
      '& .MuiPaper-root': {
        '&.MuiPaper-rounded': {
          borderRadius: '16px'
        },
        fontFamily: 'poppins',
        ...styles
      },
      '& .MuiDialogContent-root': {
        overflow: isOverflowHidden ? 'hidden' : 'auto',
        padding: '24px 24px 8px 24px'
      },
      '& .MuiDialogActions-root': {
        padding: '8px 24px 24px'
      }
    };
  },
  title: {
    '& .modal-title': {
      fontFamily: 'Poppins',
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '24px',
      margin: '0px'
    },
    padding: '32px 24px 16px 24px'
  },
  closeButton: {
    position: 'absolute',
    right: '0px',
    top: '0px'
  }
});

interface DialogTitleProps {
  children: React.ReactNode;
  classes: ClassNameMap<'root' | 'title' | 'closeButton'>;
  handleClose?: () => void;
}

const DialogTitle: React.FC<DialogTitleProps> = ({ children, handleClose, classes }) => {
  return (
    <MuiDialogTitle className={classes.title} disableTypography>
      {children}

      {handleClose && (
        <IconButton className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};

interface Props {
  children: React.ReactNode;
  contentStyle?: React.CSSProperties;
  footerActions?: React.ReactNode;
  handleClose: () => void;
  isModalOpen: boolean;
  scrollType?: 'paper' | 'body';
  styles?: React.CSSProperties;
  titleContent: React.ReactNode;
}

const Modal: React.FC<Props> = ({
  handleClose,
  isModalOpen,
  titleContent,
  footerActions,
  children,
  scrollType = 'body',
  styles = {},
  contentStyle = {}
}) => {
  const isOverflowHidden = scrollType === 'body';
  const classes: ClassNameMap<'root' | 'title' | 'closeButton'> = useStyles({
    styles,
    isOverflowHidden
  });

  return (
    <Dialog className={classes.root} onClose={handleClose} open={isModalOpen} scroll={scrollType}>
      <DialogTitle classes={classes} handleClose={handleClose}>
        {titleContent}
      </DialogTitle>

      <DialogContent style={contentStyle}>{children}</DialogContent>

      {footerActions && <DialogActions>{footerActions}</DialogActions>}
    </Dialog>
  );
};

export default Modal;
